export default {"src":"/_next/static/media/lyon.fb09dcd2.svg","height":54,"width":588};